var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlass1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9922 35H27.9922",
    stroke: "#219EBC",
    strokeWidth: 2.79808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99219 35V15C3.99219 7 5.99219 5 13.9922 5",
    stroke: "#219EBC",
    strokeWidth: 2.79808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35V15C44 7 42 5 34 5",
    stroke: "#219EBC",
    strokeWidth: 2.79808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9922 31.8188V38.3988C19.9922 42.3988 18.3922 43.9988 14.3922 43.9988H9.59219C5.59219 43.9988 3.99219 42.3988 3.99219 38.3988V31.8188C3.99219 27.8188 5.59219 26.2188 9.59219 26.2188H14.3922C18.3922 26.2188 19.9922 27.8188 19.9922 31.8188Z",
    stroke: "#219EBC",
    strokeWidth: 2.79808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9922 31.8188V38.3988C43.9922 42.3988 42.3922 43.9988 38.3922 43.9988H33.5922C29.5922 43.9988 27.9922 42.3988 27.9922 38.3988V31.8188C27.9922 27.8188 29.5922 26.2188 33.5922 26.2188H38.3922C42.3922 26.2188 43.9922 27.8188 43.9922 31.8188Z",
    stroke: "#219EBC",
    strokeWidth: 2.79808,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlass1);
export default __webpack_public_path__ + "static/media/glass1.835c31f79ee5a290adea92c89a8e9956.svg";
export { ForwardRef as ReactComponent };